<template>
  <div class="animated fadeInRight ecommerce">
    <el-row>
      <el-col :span="24">
        <el-card class="">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('serviceProvideManage.queryCondition') }}</div>
          </div>
          <el-form :inline="true" :model="serviceProvideManageInfo.conditions" class="flex justify-start">

            <el-form-item>
              <el-input v-model="serviceProvideManageInfo.conditions.serviceCode"
                :placeholder="$t('serviceProvideManage.inputServiceCode')">
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-input v-model="serviceProvideManageInfo.conditions.name"
                :placeholder="$t('serviceProvideManage.inputServiceName')">
              </el-input>
            </el-form-item>

            <el-form-item>
              <el-select v-model="serviceProvideManageInfo.conditions.queryModel"
                :placeholder="$t('serviceProvideManage.selectImplementMethod')" style="width:100%">
                <el-option label="请选择实现方式" value=""></el-option>
                <el-option label="sql方式" value="1"></el-option>
                <el-option label="java方式" value="3"></el-option>
                <el-option :label="$t('serviceProvideManage.storedProcedure')" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="_queryServiceProvideMethod" icon="el-icon-search">
                {{ $t('serviceProvideManage.query') }}
              </el-button>
              <el-button type="primary" @click="_resetServiceProvideMethod" icon="el-icon-refresh">
                {{ $t('serviceProvideManage.reset') }}
              </el-button>
            </el-form-item>

          </el-form>
        </el-card>

        <el-card class="margin-top-sm">
          <div slot="header" class="flex justify-between">
            <div>{{ $t('serviceProvideManage.serviceProvideInfo') }}</div>
            <el-button type="primary" size="small" icon="el-icon-plus" @click="_openAddServiceProvideModal"
              style="float:right">
              开发服务
            </el-button>
          </div>
          <el-table :data="serviceProvideManageInfo.serviceProvides" style="width: 100%" border>
            <el-table-column prop="id" :label="$t('serviceProvideManage.provideId')" align="center">
            </el-table-column>
            <el-table-column prop="name" :label="$t('serviceProvideManage.serviceName')" align="center">
            </el-table-column>
            <el-table-column prop="serviceCode" :label="$t('serviceProvideManage.serviceCode')" align="center">
            </el-table-column>
            <el-table-column prop="params" :label="$t('serviceProvideManage.params')" align="center">
            </el-table-column>
            <el-table-column prop="queryModel" :label="$t('serviceProvideManage.implementMethod')" align="center">
              <template slot-scope="scope">
                {{ scope.row.queryModel == '1' ? 'sql方式' : scope.row.queryModel == '2' ?
                  $t('serviceProvideManage.storedProcedure') : 'java方式' }}
              </template>
            </el-table-column>
            <el-table-column :label="$t('serviceProvideManage.operation')" align="center">
              <template slot-scope="scope">
                <el-button-group>
                  <el-button size="mini" @click="_openEditServiceProvideModel(scope.row)">
                    {{ $t('serviceProvideManage.edit') }}
                  </el-button>
                  <el-button size="mini" @click="_openDeleteServiceProvideModel(scope.row)">
                    {{ $t('serviceProvideManage.delete') }}
                  </el-button>
                </el-button-group>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
            layout="total, prev, pager, next" :total="serviceProvideManageInfo.total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>

    <edit-service-provide ref="editServiceProvide"></edit-service-provide>
    <delete-service-provide ref="deleteServiceProvide"></delete-service-provide>
  </div>
</template>

<script>
import { listServiceProvides } from '@/api/dev/serviceProvideApi'
import EditServiceProvide from '@/components/dev/editServiceProvide/editServiceProvide'
import DeleteServiceProvide from '@/components/dev/deleteServiceProvide/deleteServiceProvide'

export default {
  name: 'ServiceProvideManage',
  components: {
    EditServiceProvide,
    DeleteServiceProvide
  },
  data() {
    return {
      serviceProvideManageInfo: {
        serviceProvides: [],
        total: 0,
        records: 1,
        moreCondition: false,
        conditions: {
          id: '',
          serviceCode: '',
          name: '',
          queryModel: ''
        }
      },
      currentPage: 1,
      pageSize: 10
    }
  },
  created() {
    console.log(this.serviceProvideManageInfo.moreCondition);
    this.serviceProvideManageInfo.conditions.serviceCode = this.$route.query.serviceCode || ''
    this._listServiceProvides(this.currentPage, this.pageSize)
  },
  methods: {
    async _listServiceProvides(page, rows) {
      try {
        const params = {
          ...this.serviceProvideManageInfo.conditions,
          page,
          row: rows
        }
        const res = await listServiceProvides(params)
        this.serviceProvideManageInfo.total = res.total
        this.serviceProvideManageInfo.records = res.records
        this.serviceProvideManageInfo.serviceProvides = res.data
      } catch (error) {
        console.error('获取服务提供列表失败:', error)
      }
    },
    _openAddServiceProvideModal() {
      this.$router.push('/pages/dev/devServiceProvide')
    },
    _openEditServiceProvideModel(serviceProvide) {
      this.$refs.editServiceProvide.open(serviceProvide)
    },
    _openDeleteServiceProvideModel(serviceProvide) {
      this.$refs.deleteServiceProvide.open(serviceProvide)
    },
    _queryServiceProvideMethod() {
      this.currentPage = 1
      this._listServiceProvides(this.currentPage, this.pageSize)
    },
    _resetServiceProvideMethod() {
      this.serviceProvideManageInfo.conditions = {
        id: '',
        serviceCode: '',
        name: '',
        queryModel: ''
      }
      this._listServiceProvides(this.currentPage, this.pageSize)
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this._listServiceProvides(this.currentPage, this.pageSize)
    }
  }
}
</script>

<style scoped>
.ecommerce {}

.el-card {
  margin-bottom: 20px;
}

.el-pagination {
  margin-top: 20px;
  text-align: right;
}
</style>